import {
  DAILYPLANNING_DETAILS_REQUEST,
  DAILYPLANNING_DETAILS_SUCCESS,
  DAILYPLANNING_DETAILS_FAILURE,
} from '../../constants/types';
import { HTTP_METHOD } from '../../constants/methods';
import { selectSelectedDate, selectSelectedTeam } from '../../../reducers/areas/dailyPlanning';
import {
  setTreatmentInstances,
  setPostings,
  setTreatmentInstancesLoading,
  setPostingsLoading,
  getLocationsForPostings,
} from '../../entities';
import { callAPIMiddlewarePromise } from '../../../services/callAPIMiddleware';
import { getSelectorOptions } from '../../uiElements/selectors';
import { bandsEndpoint } from '../../../settings/constants';
import { queryStringBuilder } from '../../../utils/helpers';

export function getDailyPlanningDetails() {
  return (dispatch, getState) => {
    const currentState = getState();
    const isMapView = currentState.areas.dailyPlanning.schedulerMapView.mapViewState;
    const {
      selectedDate,
      scheduler: { isNightMode },
    } = currentState.areas.dailyPlanning;

    const action = {
      types: [DAILYPLANNING_DETAILS_REQUEST, DAILYPLANNING_DETAILS_SUCCESS, DAILYPLANNING_DETAILS_FAILURE],
      shouldCallAPI: () => true,
      buildCallParameters: state => {
        const parameters = {
          selectedDate: selectSelectedDate(state),
          teamIds: selectSelectedTeam(state),
          isNightMode,
          IsSchedulerDayNightMode: true,
        };
        return {
          method: HTTP_METHOD.GET,
          path: `v1/query/GetDailyPlanningDetails${queryStringBuilder(parameters)}`,
        };
      },
    };

    dispatch(setTreatmentInstancesLoading(false));
    dispatch(setPostingsLoading(false));
    dispatch(getSelectorOptions(bandsEndpoint, 'bands'));

    callAPIMiddlewarePromise(action, dispatch, getState).then(response => {
      const { SchedulerDayModeStartTime, SchedulerNightModeStartTime } = getState().entities.settings.appSettings;

      dispatch(setTreatmentInstances(response));
      dispatch(
        setPostings(response, isNightMode, selectedDate, SchedulerDayModeStartTime, SchedulerNightModeStartTime),
      );
      if (isMapView) {
        dispatch(getLocationsForPostings(true));
      }
    });
  };
}
